export default __webpack_public_path__ + "static/media/Cheffi.9f620a7b.apk";